import { useEffect } from 'react';
import { LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

export const useNotifications = () => {
  useEffect(() => {
    initializeNotifications();
  }, []);

  const initializeNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    // Request permissions
    await LocalNotifications.requestPermissions();
    await PushNotifications.requestPermissions();

    // Schedule weekly Friday notification
    await scheduleWeeklyReminder();
  };

  const scheduleWeeklyReminder = async () => {
    try {
      // Clear existing scheduled notifications first
      await LocalNotifications.cancel({ notifications: [{ id: 1 }] });

      // Get next Friday at 10 AM
      const now = new Date();
      const nextFriday = new Date();
      const dayOfWeek = now.getDay();
      const daysUntilFriday = (5 - dayOfWeek + 7) % 7 || 7; // 5 = Friday
      
      nextFriday.setDate(now.getDate() + daysUntilFriday);
      nextFriday.setHours(10, 0, 0, 0); // 10 AM

      const notification: ScheduleOptions = {
        notifications: [
          {
            id: 1,
            title: 'DiskOver',
            body: 'Vous prévoyez des visites ce weekend? Utilisez DiskOver pour découvrir les lieux culturels autour de vous!',
            schedule: {
              at: nextFriday,
              repeats: true,
              every: 'week'
            },
            sound: 'default',
            smallIcon: 'ic_stat_icon_config_sample'
          }
        ]
      };

      await LocalNotifications.schedule(notification);
      console.log('Weekly reminder scheduled for:', nextFriday);
    } catch (error) {
      console.error('Error scheduling weekly notification:', error);
    }
  };

  const sendPodcastCreatedNotification = async (locationName: string) => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await LocalNotifications.schedule({
        notifications: [
          {
            id: Date.now(),
            title: '🎙️ Podcast créé!',
            body: `Votre podcast sur "${locationName}" est prêt à écouter!`,
            sound: 'default',
            smallIcon: 'ic_stat_icon_config_sample'
          }
        ]
      });
    } catch (error) {
      console.error('Error sending podcast notification:', error);
    }
  };

  return {
    sendPodcastCreatedNotification,
    scheduleWeeklyReminder
  };
};